import { lazy } from "react";

//components imports
import ROUTE_NAMES from "./routeNames";
import PrivateRoute from "./privateRoute";
import MainLayout from "layout/mainLayout";
import RoutesContainer from "components/routesContainer";
import AddCongregations from "modules/add-congregation";
import AddUser from "modules/add-user";
import RequestCongregations from "modules/requestCongregation";
import RequestCongregationDetails from "modules/request-congregation";

//pages import
const Cms = RoutesContainer(lazy(() => import("modules/cms")));
const Dashboard = RoutesContainer(lazy(() => import("modules/dashboard")));
const Congregation = RoutesContainer(
  lazy(() => import("modules/congregation"))
);
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: ROUTE_NAMES.BASE_ROUTE,
  element: <MainLayout />,
  children: [
    {
      path: ROUTE_NAMES.MAIN_ROUTES.DASHBOARD, // done
      element: (
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CMS, //done
      element: (
        <PrivateRoute>
          <Cms />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS, //done
      element: (
        <PrivateRoute>
          <Congregation />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.REQUESTED_CONGREGATION, //done
      element: (
        <PrivateRoute>
          <RequestCongregations />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ADD_CONGREGATIONS, //not yet
      element: (
        <PrivateRoute>
          <AddCongregations />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.REQUESTED_CONGREGATION_DETAILS, // RequestCongregationDetails
      element: (
        <PrivateRoute>
          <RequestCongregationDetails />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.Edit_CONGREGATIONS,
      element: (
        <PrivateRoute>
          <AddCongregations />
        </PrivateRoute>
      ),
    },
    {
      path: ROUTE_NAMES.MAIN_ROUTES.ADD_USERS, //not yet
      element: (
        <PrivateRoute>
          <AddUser />
        </PrivateRoute>
      ),
    },
  ],
};

export default MainRoutes;
